
export const GERMAN_PHONE_REGEX = /^(\+)?[0-9]+([\s-][0-9]+)*$/;

export function isGermanPhoneNumber(value: string): boolean {
    return GERMAN_PHONE_REGEX.test(value);
}
